import React, { useState, useEffect, useRef } from 'react';
import style from './PillDetail.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import SwitchBox from '../../../../../components/box/SwitchBox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImgPill from '../../../../../images/user/img_pill.png';
import day_morning from '../../../../../images/common/i_day_morning_02.svg';
import day_lunch from '../../../../../images/common/i_day_lunch_02.svg';
import day_night from '../../../../../images/common/i_day_night_02.svg';
import { useNavigate } from 'react-router-dom';
import URL from "../../../../../constants/url";

//TimePicker
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

const PillDetail = () => {

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    
    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const [alarmTime, setAlarmTime] = useState({ hour: 8, minute: 0 });
    const [toggle, setToggle] = useState(false);
    const [reSwichStatus, setReSwichStatus] = useState(false);

   

    const formatTime = (hour, minute) => {
        const ampm = hour < 12 ? "오전" : "오후";
        const hr = hour % 12 === 0 ? 12 : hour % 12;
        const min = String(minute).padStart(2, "0");
        return `${ampm} ${hr}:${min}`;
    };

    return (
        <>
            <HeadSub title="복약 기록 상세" />

            <div className={style['top-control-box']}>
                <button className={style['top-control-btn']}>
                    <span>수정</span>
                </button>
                <button className={style['top-control-btn']}>
                    <span>삭제</span>
                </button>
            </div>

            <div className="container" data-padding="none"> {/* data-overflow="visible"*/}  
                <div className={style["pill-detail-box"]}>
                    <div className={style["innerbox"]}>
                        <div className={style["period-box"]}>
                            <span>
                                <img src={day_morning} alt="" />
                                아침
                            </span>
                            <span>식후 30분</span>
                        </div>
                        <div className={style["alarm-box"]}>
                            {toggle ? 
                                <strong onClick={() => setOpen(true)}>{formatTime(alarmTime.hour, alarmTime.minute)}</strong> : 
                                <strong className={style['no-alarm']}>알림 없음</strong>
                            }
                            
                            <div className="" data-swich-size="sm">
                                <SwitchBox toggles={toggle} status={setToggle} />
                            </div>
                        </div>
                        
                        <div className={style["infom-wrap"]}>

                            {toggle && (
                                <div className='animation-1'>
                                    <div className={style["infom-box"]}>
                                    <p className={style["tit"]}>다시 알림 설정</p>
                                    <SwitchBox size="small" toggles={reSwichStatus} status={setReSwichStatus}/>
                                    </div>
                                </div> 
                            )}

                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>처방 정보</p>
                                <p>
                                    <span>여의도성모</span>
                                    <span>혈액내과 처방</span>
                                </p>
                            </div>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>처방 일</p>
                                <span>24.00.00</span>
                            </div>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>약 종류</p>
                                <span>총 3개</span>
                            </div>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>복약 기간</p>
                                <span>24.00.00~24.00.00(총 00일)</span>
                            </div>
                        </div>
                    </div>
                </div>
 
                <div className={style["pill-infom-box"]}>
                    <div className="inner-wrap" data-pad="normal">

                        <div className={style['check-point-box']}>
                            <strong>꼭 확인해주세요!</strong>
                            <ul>
                                <li>처방일수가 같더라도 함께 복용하면 안되는 약이 있을 수 있습니다. 반드시 의사, 약사의 복약 지시를 확인하고 지시에 따라 복약하세요.</li>
                                <li>대체약으로 조제된 경우 실제 처방 받은 약 이름과 처방 내역의 약 이름이 다를 수 있습니다.</li>
                                <li>알림이 적용되기까지 최대 30분 정도 걸릴 수 있습니다.</li>
                            </ul>
                        </div>

                        <div className="accordion-wrap" data-type="b">

                            <div className={style['accodion-cont-box']}>
                                <strong>3일치 처방</strong>
                                <div className={style['accodion-list-box']}>
                                    <Accordion defaultExpanded>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className='group-box'>
                                                    <span>내복약</span>
                                                    <span>식후</span>
                                                </p>
                                                <div className="tit">
                                                    <p>유니비디 캡슐</p>
                                                    <span>1회 투약 시 1개 복용</span>
                                                </div>
                                                <div className="sub-tit">
                                                    <span>
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                    </span>
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='img-box'>
                                                    <img src={ImgPill} alt="" />
                                                </div>
                                                <div className='infom-box'>
                                                    <p>약품명</p>
                                                    <span>%약품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>성분명</p>
                                                    <span>%성품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>효능·효과</p>
                                                    <span>%효능·효과 노출합니다 길어지면 줄 바꿈이 필요합니다%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>부작용 및 주의사항</p>
                                                    <ul className='list-box'>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </div>


                            <div className={style['accodion-cont-box']}>
                                <strong>5일치 처방</strong>
                                <div className={style['accodion-list-box']}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                        >
                                            <div className="accordion-head">
                                                <p className='group-box'>
                                                    <span>내복약</span>
                                                    <span>식전</span>
                                                </p>
                                                <div className="tit">
                                                    <p>유니비디 캡슐</p>
                                                    <span>1회 투약 시 1개 복용</span>
                                                </div>
                                                <div className="sub-tit">
                                                    <span>
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                    </span>
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                        <div className="accordion-body">
                                                <div className='img-box'>
                                                    <img src={ImgPill} alt="" />
                                                </div>
                                                <div className='infom-box'>
                                                    <p>약품명</p>
                                                    <span>%약품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>성분명</p>
                                                    <span>%성품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>효능·효과</p>
                                                    <span>%효능·효과 노출합니다 길어지면 줄 바꿈이 필요합니다%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>부작용 및 주의사항</p>
                                                    <ul className='list-box'>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                        >
                                            <div className="accordion-head">
                                                <p className='group-box'>
                                                    <span>내복약</span>
                                                    <span>식후</span>
                                                </p>
                                                <div className="tit">
                                                    <p>유니비디 캡슐</p>
                                                    <span>1회 투약 시 1개 복용</span>
                                                </div>
                                                <div className="sub-tit">
                                                    <span>
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                    </span>
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                        <div className="accordion-body">
                                                <div className='img-box'>
                                                    <img src={ImgPill} alt="" />
                                                </div>
                                                <div className='infom-box'>
                                                    <p>약품명</p>
                                                    <span>%약품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>성분명</p>
                                                    <span>%성품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>효능·효과</p>
                                                    <span>%효능·효과 노출합니다 길어지면 줄 바꿈이 필요합니다%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>부작용 및 주의사항</p>
                                                    <ul className='list-box'>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div> 
                            </div>

                            <div className={style['accodion-cont-box']}>
                                <strong>7일치 처방</strong>
                                <div className={style['accodion-list-box']}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                        >
                                            <div className="accordion-head">
                                                <p className='group-box'>
                                                    <span>내복약</span>
                                                    <span>식후</span>
                                                </p>
                                                <div className="tit">
                                                    <p>%약제명%</p>
                                                    <span>1회 투약 시 1개 복용</span>
                                                </div>
                                                <div className="sub-tit">
                                                    <span>
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                        어쩌고 저쩌고 효능이 여기에
                                                        노출됩니다 한 줄보다 길어지지
                                                        않고 말줄임 됩니다
                                                    </span>
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                        <div className="accordion-body">
                                                <div className='img-box'>
                                                    <img src={ImgPill} alt="" />
                                                </div>
                                                <div className='infom-box'>
                                                    <p>약품명</p>
                                                    <span>%약품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>성분명</p>
                                                    <span>%성품명 노출%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>효능·효과</p>
                                                    <span>%효능·효과 노출합니다 길어지면 줄 바꿈이 필요합니다%</span>   
                                                </div>
                                                <div className='infom-box'>
                                                    <p>부작용 및 주의사항</p>
                                                    <ul className='list-box'>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                        <li>%부작용 및 주의사항 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 길어지면 줄바꿈</li>
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </div>
                        </div>


                        <div className={style['btn-box']}>
                            <button className='btn' data-btn-type="fill-main" data-btn-size='sm' data-btn-icon='arrow' onClick={()=> navigate(URL.HOSPITAL_PRESCRIPTIONHISTORY)}>
                                <span>전체 처방 내역</span>
                            </button>    
                        </div> 
                    </div>
                </div>


                <BottomSheet
                    scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                    expandOnContentDrag={false} // 내용 드래그로 확장 방지
                    open={open}
                    onDismiss={onDismiss}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking={true}
                        >
                        <CustomTimePicker 
                            onClose={onDismiss} 
                            onConfirm={(time) => {
                                setAlarmTime(time);
                                onDismiss(); // 바텀시트 닫기
                            }}
                            titleTxt="알림 시간 선택"
                        /> 
                </BottomSheet>    



            </div>
        </>
    );
};

export default PillDetail;
